import { EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import GlobalModel from 'echarts/lib/model/Global';
import { type default as SymbolClz } from 'echarts/lib/chart/helper/Symbol';
import { DvLineSeriesModel } from './type';
import { isValidNumericValue } from './util';

function parseDvSymbolZ(ecModel: GlobalModel) {
  const lineModels = ecModel.getSeriesByType('line');
  lineModels.forEach((model: DvLineSeriesModel) => {
    const data = model.getData();
    const dvSymbolZ = model.get('dvSymbolZ');
    const zLevel = model.get('zlevel');
    if (!isValidNumericValue(dvSymbolZ)) {
      return;
    }

    data.eachItemGraphicEl((el: SymbolClz) => {
      if (!el) {
        return;
      }
      el.setZ(dvSymbolZ, zLevel);
    });
  });
}

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('series:afterupdate', ecModel => {
    // 添加扩展方法
    parseDvSymbolZ(ecModel);
  });
}
